export default __webpack_public_path__ + "static/media/gallery-wip-pommel_01.6c16d982.jpg";